<template>
  <section class="pressa-banner position-relative overflow-hidden rounded-sm pa-6 border">
    <span class="banner-overlay-darken" />
    <div class="d-flex flex-column position-relative bg-gray-0--text">
      <p class="text-body-1">
        <!-- eslint-disable max-len vue/max-len -->
        {{ t('«Лучшая в мире система клиентского сервиса является и самой простой: делай то, что обещал, и делай это с первого раза.»', options) }}
        <!-- eslint-enable max-len vue/max-len -->
      </p>
      <div class="text-right text-body-1">
        {{ t('— Карл Сьюэлл', options) }}
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
import I18NextVue from 'i18next'

const { t, language } = I18NextVue
const options = { ns: language }
</script>

<style scoped lang="scss">
.pressa-banner {
  background: url('/static/_v1/pd/banners/pressa-banner.jpeg') 50% 22%/cover no-repeat
}

.banner-overlay-darken {
  background: #36363699;
  position: absolute;
  inset: 0;
}
</style>
